import { colors } from "./colors";
import { mixins } from "./mixins";
import { link } from "./link";
import { checkbox } from "./checkbox";
import { stepper } from "./stepper";
import { Theme } from "./types";
import { breakpoints } from "./breakpoints";
import { avatar } from "./avatar";
import { radio } from "./radio";
import { font } from "./font";

const theme: Theme = {
    link,
    mixins,
    colors,
    stepper,
    radio,
    checkbox,
    avatar,
    breakpoints,
    font,
};

export default theme;
